import { User } from 'firebase/auth';

// Whitelist of admin email addresses
const ADMIN_EMAILS = [
  'vikas.shah.1976@gmail.com',
  'vikas@shahlab.org',
];

/**
 * Check if a user is an admin based on their email and authentication method
 */
export function isUserAdmin(user: User | null): boolean {
  if (!user || !user.email) {
    return false;
  }

  // Must be authenticated with Google (not anonymous)
  if (user.isAnonymous) {
    return false;
  }

  // Must have a Google provider in their provider data
  const hasGoogleProvider = user.providerData.some(
    provider => provider.providerId === 'google.com'
  );

  if (!hasGoogleProvider) {
    return false;
  }

  // Email must be in the whitelist
  const isWhitelisted = ADMIN_EMAILS.includes(user.email.toLowerCase());

  return isWhitelisted;
}

/**
 * Get the current user's admin status and details
 */
export function getAdminInfo(user: User | null) {
  const isAdmin = isUserAdmin(user);
  
  return {
    isAdmin,
    email: user?.email || null,
    isGoogleAuth: user?.providerData.some(p => p.providerId === 'google.com') || false,
    isAnonymous: user?.isAnonymous || false,
  };
}